import groupBy from 'lodash/groupBy';
import orderBy from 'lodash/orderBy';

import { Achievement, AchievementState, Category } from '../../../types/achievements.types';
import { AchievementBadge } from './types';

export function computePercentage(achievements: Achievement[]): number {
  const unlocked = achievements.filter((a) => a.state === AchievementState.COMPLETED);
  const calc = (unlocked.length / achievements.length) * 100;
  return Math.round(calc) || 0;
}

export function computeAchievementBadgesByCategory(
  achievements: Achievement[],
  categories: Category[],
): Record<string, AchievementBadge[]> | Record<string, unknown> {
  const formatedBadges = achievements.map((achievement, index) => {
    const { categoryId, label, data, points, state, _id, status, media } = achievement;
    const category = categories.find((c) => c._id === categoryId);
    const isLocked = state !== AchievementState.COMPLETED;
    return {
      _id,
      title: label,
      points,
      category: {
        label: category?.label,
        _id: category?._id,
        description: category?.data?.description,
        order: category?.data?.order,
      },
      order: data?.order ?? index * 100000,
      image: media,
      locked: isLocked,
      state,
      status,
    };
  });

  const orderedBadge = orderBy(formatedBadges, ['category.order', 'order'], ['asc', 'asc']);
  return groupBy(orderedBadge, 'category._id');
}
